import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prjectMgm, auditBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
  export const phaseMasterService = createApi({
    reducerPath: 'phaseMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: auditBaseUrl }),
    tagTypes: ['PhaseMaster'],
    endpoints: (builder) => ({
        getAllPhaseMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.phaseMasterController.getAllPhaseMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getPhaseMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.phaseMasterController.getPhaseMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        savePhaseMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.phaseMasterController.savePhaseMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        updatePhaseMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.phaseMasterController.updatePhaseMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        deletePhaseMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.phaseMasterController.deletePhaseMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getAllPhaseMasterWithSearch: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.phaseMasterController.getAllPhaseMasterWithSearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                };
            },
        }),
        findAllPhaseMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.phaseMasterController.findAllPhaseMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
    })
  });
  export const {
    useGetAllPhaseMasterMutation,
    useSavePhaseMasterMutation,
    useUpdatePhaseMasterMutation,
    useDeletePhaseMasterMutation,
    useGetPhaseMasterByIdMutation,
    useGetAllPhaseMasterWithSearchMutation,
    useFindAllPhaseMasterMutation,
  } = phaseMasterService;